import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-[750px] min-h-svh flex flex-col justify-center pt-24 md:pt-20" data-id="element-374" data-mp="sb1chsl5257m">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-375" data-mp="nbexpepnwgwp">
        <img src="https://cdn.shopify.com/s/files/1/0740/9788/5319/files/IMG-20260606-WA0000.jpg?v=1780717082" alt="Flash & Go Showroom" className="w-full h-full object-cover object-center" data-id="element-376" data-mp="nekkuoeqd8ps" />
        <div className="absolute inset-0 bg-black/60" data-id="element-377" data-mp="3j7zc59vbxccg"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 w-full flex-grow flex flex-col justify-center pb-10 md:pb-32" data-id="element-378" data-mp="3o7ls3r2jl6oy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl" data-id="element-379" data-mp="39b4ib4a0404i">
          <h1 className="font-heading text-7xl md:text-8xl lg:text-9xl leading-[0.85] mb-6" data-id="element-380" data-mp="358hmyte4fx2k">
            <span className="text-brand-white block" data-id="element-381" data-mp="2qjv4wjx40r7n">COMPRÁ, ALQUILÁ</span>
            <span className="text-brand-gold block" data-id="element-382" data-mp="2qhqvjmgfyzzz">O INVERTÍ.</span>
          </h1>

          <p className="text-xl md:text-2xl text-brand-white/90 font-light mb-12" data-id="element-383" data-mp="2vj7tb93mq6cc">
            Tu capital sobre ruedas.
          </p>

          <div className="flex flex-col items-stretch gap-3 max-w-[280px] mx-auto sm:max-w-none sm:mx-0 sm:flex-row sm:flex-wrap sm:gap-4" data-id="element-384" data-mp="2lkqx9xpu31jf">
            <button onClick={() => scrollToSection('stock')} className="px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors text-center" data-id="element-385" data-mp="s332p6wnmcud">
              Comprar un auto
            </button>
            <button onClick={() => scrollToSection('alquiler')} className="px-8 py-4 border-2 border-brand-gold text-brand-gold font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors text-center" data-id="element-386" data-mp="ddng8345otkh">
              Alquilar para apps
            </button>
            <button onClick={() => scrollToSection('consignacion')} className="px-8 py-4 border-2 border-brand-gold text-brand-gold font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors text-center" data-id="element-387" data-mp="111ol9224lrv5">
              Dejar en consignación
            </button>
            <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" className="px-8 py-4 border-2 border-brand-gold text-brand-gold font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors text-center" data-id="element-388" data-mp="3hpsft8nytx3m">
              Invertir
            </a>
          </div>
        </motion.div>
      </div>

      {/* Stats Bar */}
      <div className="relative md:absolute md:bottom-0 left-0 right-0 z-20 bg-brand-black/80 backdrop-blur-md border-t border-brand-gold/30" data-id="element-389" data-mp="2b20qh34cm28m">
        <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-390" data-mp="2kynbpt0l6vb6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-px md:divide-x md:divide-brand-gold/20" data-id="element-391" data-mp="2kx2ge16g78c9">
            {[{
            title: 'Compra y Venta',
            desc: 'Autos 0km y usados'
          }, {
            title: 'Alquiler para Apps',
            desc: 'Uber, Cabify y más'
          }, {
            title: 'Financiación',
            desc: 'Hasta el 100%'
          }, {
            title: '2% mensual',
            desc: '24% anual en dólares'
          }].map((stat, i) => <div key={i} className="py-5 md:py-6 px-3 md:px-4 text-center" data-id="element-392" data-mp="3vk1hdtkm3sv4" data-mpi={i}>
                <h3 className="font-heading text-2xl text-brand-gold mb-1" data-id="element-393" data-mp="e8schd8aoufv">
                  {stat.title}
                </h3>
                <p className="text-sm text-brand-white/70" data-id="element-394" data-mp="3hqabcv63ar45">{stat.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}